/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FundCode } from './FundCode';
import {
    FundCodeFromJSON,
    FundCodeFromJSONTyped,
    FundCodeToJSON,
    FundCodeToJSONTyped,
} from './FundCode';

/**
 * 
 * @export
 * @interface Allocation
 */
export interface Allocation {
    /**
     * 
     * @type {FundCode}
     * @memberof Allocation
     */
    fundCode: FundCode;
    /**
     * 
     * @type {string}
     * @memberof Allocation
     */
    fundName: string;
    /**
     * 
     * @type {number}
     * @memberof Allocation
     */
    allocation: number;
}



/**
 * Check if a given object implements the Allocation interface.
 */
export function instanceOfAllocation(value: object): value is Allocation {
    if (!('fundCode' in value) || value['fundCode'] === undefined) return false;
    if (!('fundName' in value) || value['fundName'] === undefined) return false;
    if (!('allocation' in value) || value['allocation'] === undefined) return false;
    return true;
}

export function AllocationFromJSON(json: any): Allocation {
    return AllocationFromJSONTyped(json, false);
}

export function AllocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Allocation {
    if (json == null) {
        return json;
    }
    return {
        
        'fundCode': FundCodeFromJSON(json['fundCode']),
        'fundName': json['fundName'],
        'allocation': json['allocation'],
    };
}

export function AllocationToJSON(json: any): Allocation {
    return AllocationToJSONTyped(json, false);
}

export function AllocationToJSONTyped(value?: Allocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fundCode': FundCodeToJSON(value['fundCode']),
        'fundName': value['fundName'],
        'allocation': value['allocation'],
    };
}

